<template>
  <div>
    <form @submit.prevent>
      <div class="row">
        <div class="col-md-6">
          <div class="create-user-form__section">
            <div class="create-user-form__section-title">
              {{ $t("students.login_data") }}
            </div>
            <el-input
              v-bind:class="{
                showLabel: userData.login || error.login.invalid,
                error: error.login.invalid,
              }"
              type="text"
              name="login"
              :placeholder="`${$t('labels.login')} *`"
              v-model="userData.login"
              @input="
                authLookup('login'), resetError('login'), resetError('email')
              "
            >
              <label
                v-if="error.login.invalid"
                class="label-error"
                slot="prefix"
                >{{ error.login.message }}</label
              >
              <label v-else slot="prefix">{{ $t("labels.login") }}</label>
            </el-input>
            <el-input
              v-bind:class="{
                showLabel: userData.email || error.email.invalid,
                error: error.email.invalid,
              }"
              type="email"
              name="email"
              :placeholder="`${$t('labels.email')} *`"
              v-model="userData.email"
              @input="
                authLookup('email'), resetError('email'), resetError('login')
              "
            >
              <label
                v-if="error.email.invalid"
                class="label-error"
                slot="prefix"
                >{{ error.email.message }}</label
              >
              <label v-else slot="prefix">{{ $t("labels.email") }}</label>
            </el-input>
            <div
              class="el-input el-input--prefix"
              v-bind:class="{
                showLabel: userData.phone || error.phone.invalid,
                error: error.phone.invalid,
              }"
            >
              <el-input
                v-bind:class="{
                  showLabel: userData.phone || error.phone.invalid,
                  error: error.phone.invalid,
                }"
                type="tel"
                name="phone"
                :placeholder="`${$t('labels.phone')} *`"
                v-model="userData.phone"
                @input="authLookup('phone'), resetError('phone')"
              >
                <label
                  v-if="error.phone.invalid"
                  class="label-error"
                  slot="prefix"
                  >{{ error.phone.message }}</label
                >
                <label v-else slot="prefix">{{ $t("labels.phone") }}</label>
              </el-input>
            </div>

            <password-input
              :invalid="error.password.invalid && error.password.message"
              :defaultClass="{
                showLabel: userData.password || error.password.invalid,
                error: error.password.invalid,
              }"
              v-model="userData.password"
              @input="resetError('password')"
              :placeholder="`${$t('labels.password')} *`"
              required="required"
              :label="$t('labels.password')"
              @passwordGenerated="onPasswordGenerated"
            ></password-input>
          </div>
        </div>
        <div class="col-md-6">
          <div class="create-user-form__section">
            <div class="create-user-form__section-title">
              {{ $t("labels.fio") }}
            </div>
            <el-input
              v-bind:class="{
                showLabel: userData.last_name || error.last_name.invalid,
                error: error.last_name.invalid,
              }"
              type="text"
              name="last_name"
              :placeholder="`${$t('labels.surname')} *`"
              v-model="userData.last_name"
              @blur="capitalize('last_name')"
              @input="resetError('last_name')"
            >
              <label
                v-if="error.last_name.invalid"
                class="label-error"
                slot="prefix"
                >{{ error.last_name.message }}</label
              >
              <label v-else slot="prefix">{{ $t("labels.surname") }}</label>
            </el-input>
            <el-input
              v-bind:class="{
                showLabel: userData.first_name || error.first_name.invalid,
                error: error.first_name.invalid,
              }"
              type="text"
              :placeholder="`${$t('labels.name')} *`"
              name="first_name"
              v-model="userData.first_name"
              @blur="capitalize('first_name')"
              @input="resetError('first_name')"
            >
              <label
                v-if="error.first_name.invalid"
                class="label-error"
                slot="prefix"
                >{{ error.first_name.message }}</label
              >
              <label v-else slot="prefix">{{ $t("labels.name") }}</label>
            </el-input>
            <el-input
              v-bind:class="{
                showLabel: userData.middle_name || error.middle_name.invalid,
                error: error.middle_name.invalid,
              }"
              type="text"
              name="middle_name"
              :placeholder="$t('labels.middle_name')"
              @blur="capitalize('middle_name')"
              v-model="userData.middle_name"
            >
              <label
                v-if="error.middle_name.invalid"
                class="label-error"
                slot="prefix"
                >{{ error.middle_name.message }}</label
              >
              <label v-else slot="prefix">{{ $t("labels.middle_name") }}</label>
            </el-input>
          </div>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-md-6">
          <el-checkbox
            class="create-user-form-send-to-email"
            :checked="userData.send_to_email"
            v-model="userData.send_to_email"
          >Отправить данные для входа,
            <br>на email сотрудника
          </el-checkbox>
        </div>
      </div> -->
    </form>
  </div>
</template>
<script>
import MaskedInput from "vue-masked-input";
import _ from "lodash";
import PasswordInput from "src/components/Authenticate/PasswordInput";
import capitalize from "src/filters/capitalize";
import auth from "src/services/auth";
import { normPhone } from "@/lib/phone";

const emptyData = {
  login: "",
  email: "",
  phone: "",
  password: "",
  first_name: "",
  last_name: "",
  middle_name: "",
  // send_to_email: true
};

export default {
  components: {
    PasswordInput,
    MaskedInput,
  },
  data() {
    return {
      testData: "",
      userData: {},
      superadmin: false,
      passwordFieldtype: "password",
      error: {
        login: {
          invalid: false,
          message: "",
        },
        email: {
          invalid: false,
          message: "",
        },
        phone: {
          invalid: false,
          message: "",
        },
        password: {
          invalid: false,
          message: "",
        },
        first_name: {
          invalid: false,
          message: "",
        },
        middle_name: {
          invalid: false,
          message: "",
        },
        last_name: {
          invalid: false,
          message: "",
        },
      },
    };
  },
  methods: {
    capitalize(path) {
      this.userData[path] = capitalize(this.userData[path]);
    },
    onPasswordGenerated(password) {
      this.userData.password = password;
    },
    showPassword() {
      if (this.passwordFieldtype === "password") {
        this.passwordFieldtype = "text";
      } else {
        this.passwordFieldtype = "password";
      }
    },
    setError(key, message) {
      this.error[key].invalid = true;
      this.error[key].message = message;
    },
    formReset() {
      this.userData = {
        login: "",
        email: "",
        phone: "",
        password: "",
        first_name: "",
        last_name: "",
        middle_name: "",
      };
    },
    authLookup: _.debounce(async function(authMethod) {
      let self = this;
      let message = "";

      if (!this.userData[authMethod]) return;

      let authData =
        authMethod === "phone"
          ? normPhone(this.userData[authMethod])
          : this.userData[authMethod];

      switch (authMethod) {
        case "login":
          message = this.$t("labels.login_is_used");
          break;
        case "email":
          message = this.$t("labels.email_is_used");
          break;
        case "phone":
          message = this.$t("labels.phone_is_used");
          break;
      }
      let response = await auth.authLookup(authData);
      if (response) {
        self.setError(authMethod, message);
      }
    }, 1000),
    validate() {
      function validateEmail(email) {
        let regexp = /^[A-z0-9._-]+@[A-z0-9.-]+\.[A-z]{2,4}$/;
        return regexp.test(email);
      }

      function validateLogin(login) {
        let regexp = /^[A-z0-9._-]{3,}$/;
        return regexp.test(login);
      }

      function validatePhone(phone) {
        let regexp = /^[+0-9-()\s]{10,}$/;
        return regexp.test(phone);
      }

      function validatePass(password) {
        let regexp = /^[A-z0-9!$^&]+$/;
        return regexp.test(password);
      }

      function validatePassLength(password) {
        let regexp = /^[A-z0-9!$^&]{6,}$/;
        return regexp.test(password);
      }

      if (!this.userData.login && !this.userData.email) {
        this.setError("login", this.$t("labels.enter_login_or_email"));
      } else if (!validateLogin(this.userData.login) && !this.userData.email) {
        this.setError("login", this.$t("labels.use_latin_symbols_and_numbers"));
      }

      if (this.userData.login) {
        this.resetError("email");
      } else if (!this.userData.email && !this.userData.login) {
        this.setError("email", this.$t("labels.enter_login_or_email"));
      } else if (!validateEmail(this.userData.email) && !this.userData.login) {
        this.setError("email", this.$t("labels.enter_valid_email"));
      }

      // if (!this.userData.login && !this.userData.email) {
      //   this.setError('login', this.$t('labels.enter_login_or_email'))
      // } else if (!validateLogin(this.userData.login)) {
      //   this.setError('login', this.$t('labels.use_latin_symbols_and_numbers'))
      // }

      // if (!this.userData.email) {
      //   this.setError('email', 'Укажите email или login')
      // } else if (!validateEmail(this.userData.email)) {
      //   this.setError('email', this.$t('labels.enter_valid_email'))
      // }

      if (!this.userData.phone) {
        this.setError("phone", this.$t("labels.required_field"));
      } else if (!validatePhone(this.userData.phone)) {
        this.setError("phone", this.$t("labels.enter_valid_phone"));
      }

      if (!this.userData.password) {
        this.setError("password", this.$t("labels.required_field"));
      } else if (!validatePass(this.userData.password)) {
        this.setError(
          "password",
          this.$t("labels.password_must_contain_latin_symbols_and_other")
        );
      } else if (!validatePassLength(this.userData.password)) {
        this.setError("password", this.$t("labels.min_length_password"));
      }

      if (!this.userData.last_name) {
        this.setError("last_name", this.$t("labels.required_field"));
      }

      if (!this.userData.first_name) {
        this.setError("first_name", this.$t("labels.required_field"));
      }
    },
    resetError(field) {
      if (field) {
        this.error[field].invalid = false;
        this.error[field].mesage = "";
      } else {
        for (let item in this.error) {
          this.error[item].invalid = false;
          this.error[item].mesage = "";
        }
      }
    },
    isStepValid() {
      this.validate();
      let error = this.error;
      let isValid = true;
      for (let item in error) {
        if (this.error[item].invalid === true) {
          isValid = false;
        }
      }
      return isValid;
    },
    getData() {
      let data = _.cloneDeep(this.userData);
      let emptyKeys = [];
      for (let key in data) {
        if (!data[key]) {
          emptyKeys.push(key);
        }
      }

      for (let key of emptyKeys) {
        delete data[key];
      }
      return data;
    },
  },
  computed: {
    passChange() {
      return this.userData.password;
    },
  },
  mounted() {
    this.userData = _.clone(emptyData);
  },
  watch: {
    passChange() {
      this.resetError("password");
    },
    userData: {
      handler: function(val, oldVal) {
        if (_.isEqual(emptyData, this.userData)) {
          this.$store.commit("saveGuard/setStatus", {
            key: "createUser",
            value: false,
          });
        } else {
          this.$store.commit("saveGuard/setStatus", {
            key: "createUser",
            value: true,
          });
        }
      },
      deep: true,
    },
  },
};
</script>
